import { Select, Row, Col } from "antd"
import moment from "moment"
import { FC, useContext, useState } from "react"
import MyCalendar from "./MyCalendar"
import ruRU from 'antd/es/calendar/locale/ru_RU'
import useWindowDimensions from "../../../../core/hooks/useWindowDimensions"
import { observer } from "mobx-react-lite"
import { Context } from "../../../.."

interface CalendarProps {
  available: string[]
  onSelectDate: (ev: any) => void
}

const Calendar: FC<CalendarProps> = ({
  available, onSelectDate
}) => {

  const { store } = useContext(Context)

  const { width } = useWindowDimensions()

  const [minDate, setMinDate] = useState(moment())
  const [maxDate, setMaxDate] = useState(moment().add("+40", "days"))
  const [selectedDate, setSelectedDate] = useState(moment().add("+1", "days"))

  return (
    <>
      <MyCalendar 
        validRange={[minDate, maxDate]}
        locale={ruRU}
        // style={width == "" ? {} : {width: width}}
        defaultValue={selectedDate}
        value={selectedDate}
        disabledDate={(date) => {
          // console.log(date)
          let ext = date.format("YYYY-MM-DD")
          let exist = available.find(av => av == ext)
          console.log(ext, exist)
          if (exist == undefined) {
            return true
          }
          return false
        }}
        onChange={(ev) => {
          setSelectedDate(ev)
        }}
        onSelect={(ev) => {
          console.log(ev)
          if (store.monthActive) {
            store.setMonthActive(false)
          } else {
            onSelectDate(ev)
          }
        }}
        headerRender={({ value, type, onChange, onTypeChange }) => {
          const nowMonth = moment().get("month")
          let countMonths = 12
          
          const start = moment().get("month")
          const end = countMonths
          const monthOptions = []
          const monthOptionsX = []

          let current = value.clone();
          const localeData = value.localeData();
          const months = [];
          for (let i = 0; i < 12; i++) {
            current = current.month(i);
            months.push(localeData.months(current))
          }

          for (let i = start; i < end; i++) {
            monthOptions.push(
              <Select.Option key={i} value={i} className="month-item">
                {months[i]}
              </Select.Option>,
            )
            monthOptionsX.push({name: months[i], index: i})
          }

          const year = value.year()
          const month = value.month()
          const options = [];
          for (let i = year - 10; i < year + 10; i += 1) {
            options.push(
              <Select.Option key={i} value={i} className="year-item">
                {i}
              </Select.Option>,
            );
          }
          return (
            <>
              <div style={{ padding: "0 0 0 20px" }}>
                <div className="tabbed_months">
                  {monthOptionsX.slice(0, 2).map((mnth, ix) => <div className={`tm_item ${mnth.index == month ? "selected" : ""}`} onClick={() => {
                    store.setMonthActive(true)
                    const now = value.clone().month(mnth.index)
                    console.log(now)
                    onChange(now)
                  }}>{mnth.name}</div>)}
                </div>
              </div>
            </>
          )
        }} />
    </>
  )
}

export default observer(Calendar)